(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initMarquee = (root = document) => {
    if (prefersReducedMotion.matches) {
      return;
    }

    const tracks = root.querySelectorAll('.announcement-marquee__track');
    tracks.forEach((track) => {
      const viewport = track.closest('.announcement-marquee__viewport');
      if (!viewport) return;

      track.querySelectorAll('[data-generated-clone="true"]').forEach((node) => node.remove());

      const baseNodes = Array.from(track.children).filter((node) => {
        if (node.dataset.generatedClone === 'true') return false;
        if (node.classList.contains('announcement-marquee__item--clone')) return false;
        if (node.classList.contains('announcement-marquee__separator--clone')) return false;
        return (
          node.classList.contains('announcement-marquee__item') ||
          node.classList.contains('announcement-marquee__separator')
        );
      });

      const hasItems = baseNodes.some((node) => node.classList.contains('announcement-marquee__item'));
      if (!hasItems) return;

      const viewportWidth = viewport.getBoundingClientRect().width;
      if (!viewportWidth) return;

      let trackWidth = track.scrollWidth;

      while (trackWidth < viewportWidth * 2) {
        const fragment = document.createDocumentFragment();
        baseNodes.forEach((node) => {
          const clone = node.cloneNode(true);
          clone.dataset.generatedClone = 'true';
          clone.setAttribute('aria-hidden', 'true');

          if (clone.classList.contains('announcement-marquee__item')) {
            clone.classList.add('announcement-marquee__item--clone');
            clone.querySelectorAll('a, button, input, select, textarea').forEach((focusable) => {
              focusable.setAttribute('tabindex', '-1');
              focusable.setAttribute('aria-hidden', 'true');
            });
          } else if (clone.classList.contains('announcement-marquee__separator')) {
            clone.classList.add('announcement-marquee__separator--clone');
          }

          fragment.appendChild(clone);
        });

        track.appendChild(fragment);
        trackWidth = track.scrollWidth;
      }
    });
  };

  const debouncedInit = (() => {
    let timeoutId;
    return () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => initMarquee(document), 150);
    };
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMarquee(document));
  } else {
    initMarquee(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initMarquee(event.target);
  });

  window.addEventListener('resize', debouncedInit);

  if (typeof prefersReducedMotion.addEventListener === 'function') {
    prefersReducedMotion.addEventListener('change', (event) => {
      if (event.matches) {
        document
          .querySelectorAll('[data-generated-clone="true"]')
          .forEach((node) => node.remove());
      } else {
        initMarquee(document);
      }
    });
  }
})();
